<script>
export default {
  name: 'IconChartVerticalNewUx',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.75 13.75H1.25C0.99375 13.75 0.78125 13.5375 0.78125 13.2812C0.78125 13.025 0.99375 12.8125 1.25 12.8125H13.75C14.0063 12.8125 14.2188 13.025 14.2188 13.2812C14.2188 13.5375 14.0063 13.75 13.75 13.75Z"
      :fill="color"
    />
    <path
      d="M6.09375 2.5V13.75H8.90625V2.5C8.90625 1.8125 8.625 1.25 7.78125 1.25H7.21875C6.375 1.25 6.09375 1.8125 6.09375 2.5Z"
      :fill="color"
    />
    <path
      d="M1.875 6.25V13.75H4.375V6.25C4.375 5.5625 4.125 5 3.375 5H2.875C2.125 5 1.875 5.5625 1.875 6.25Z"
      :fill="color"
    />
    <path
      d="M10.625 9.375V13.75H13.125V9.375C13.125 8.6875 12.875 8.125 12.125 8.125H11.625C10.875 8.125 10.625 8.6875 10.625 9.375Z"
      :fill="color"
    />
  </svg>
</template>
